import ReactPixel from 'react-facebook-pixel'

export const FB_PIXEL_ID = '1545009850674181'

let initialized = false

export function initFacebookPixel() {
  if (initialized || typeof window === 'undefined') return
  ReactPixel.init(FB_PIXEL_ID)
  ReactPixel.pageView()
  initialized = true
}

export function trackInitiateCheckout(plan?: string) {
  if (typeof window === 'undefined') return
  ReactPixel.track('InitiateCheckout', plan ? { content_name: plan } : {})
}
